export function parseChoiceItems(values) {
    return values.map(item => {
        const parsedItem = { id: item.id, value: item.value };
        if (item.choice_items) {
            parsedItem.choice_items = parseChoiceItems(item.choice_items);
        }
        return parsedItem;
    });
}
